import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'components/Card';
import Button from 'components/Button';
import StickyBox from 'components/StickyBox';
function EditorPageStickySaveButton(_ref) {
  var isDisabled = _ref.isDisabled,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    _ref$isEditMode = _ref.isEditMode,
    isEditMode = _ref$isEditMode === void 0 ? false : _ref$isEditMode;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m"
  }, /*#__PURE__*/React.createElement(Card, {
    px: "m",
    py: "s",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    type: "submit",
    isDisabled: isDisabled,
    isLoading: isLoading,
    icon: "ok",
    onClick: onClick
  }, t(isEditMode ? 'actions_save_changes' : 'actions_add'))));
}
export default EditorPageStickySaveButton;